/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import clsx from 'clsx'
import Typo from 'constants/typography'
import styles from './style.scss'

class PickupDetail extends React.Component {
  renderBTS = (bts) => (
    <span className={Typo.body2} key={bts}>
      {bts}
    </span>
  )

  renderHours(hour) {
    if (!hour) {
      return null
    }

    const [day, ...time] = hour.split(':')
    let parsedTime = '-'

    if (time) {
      parsedTime = time.toString().split(',').join(':')
    }

    return (
      <span className={clsx(Typo.body2, 'pdc__info-hours')} key={hour}>
        <span>{[day || '-', parsedTime].join(':')}</span>
      </span>
    )
  }

  renderTime(location, t) {
    if (!location?.hours?.length) {
      return null
    }

    return (
      <div className="pdc__info">
        <span className={clsx(Typo.subtitle2, 'pdc__info-title')}>
          {t('Hours')}
        </span>
        {location?.hours?.map(this.renderHours)}
      </div>
    )
  }

  renderInformationArea = (location, t) => {
    const btsData =
      location && location.nearest_bts && location.nearest_bts.split(',')

    return (
      <div className="pdc__information-area">
        {location.address2 && (
          <span className={Typo.body2}>{location.address2}</span>
        )}
        {this.renderTime(location, t)}
        {location.phone && (
          <div className="pdc__info">
            <span className={clsx(Typo.subtitle2, 'pdc__info-title')}>
              {t('Tel')}
            </span>
            <span className={Typo.body2}>{location.phone}</span>
          </div>
        )}
        {btsData && (
          <div className="pdc__info">
            <span className={clsx(Typo.subtitle2, 'pdc__info-title')}>
              {t('Closest BTS Station')}
            </span>
            {btsData && btsData.map(this.renderBTS)}
          </div>
        )}
      </div>
    )
  }

  render() {
    const { location, t } = this.props
    return (
      <div className="pickup-detail-component">
        <style jsx>{styles}</style>
        {this.renderInformationArea(location, t)}
      </div>
    )
  }
}

PickupDetail.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
}

export { PickupDetail }
const Extended = translate('global')(PickupDetail)

export default connect(
  /* istanbul ignore next */
  (state) => state,
)(Extended)
